// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BillingInvoiceItemGuaranteeResponse

import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type BillingInvoiceItemGuaranteeApiResponse = {
	id: number;
	date: string;
	amount: number;
	rate: number;
	bookingId: string | null;
	customerName: string | null;
};

export type BillingInvoiceItemGuarantee = {
	id: number;
	date: DateTime;
	amount: number;
	rate: number;
	bookingId: string | null;
	customerName: string | null;
};

export function hydrateBillingInvoiceItemGuarantee(data: BillingInvoiceItemGuaranteeApiResponse): BillingInvoiceItemGuarantee {
	return {
		...data,
		date: DateTimefromISO(data.date)!,
	};
}